/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { ItemManufactureProcessTypes } from './Actions';
import INITIAL_STATE from './InitialState';

export const itemManufactureProcessFetchItemProcessLoading = (state, { boolean }) => ({
  ...state,
  processIsLoading: boolean
});

export const itemManufactureProcessFetchItemProcessSuccess = (state, { process }) => ({
  ...state,
  process
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [ItemManufactureProcessTypes.ITEM_MANUFACTURE_PROCESS_FETCH_ITEM_PROCESS_LOADING]: itemManufactureProcessFetchItemProcessLoading,
  [ItemManufactureProcessTypes.ITEM_MANUFACTURE_PROCESS_FETCH_ITEM_PROCESS_SUCCESS]: itemManufactureProcessFetchItemProcessSuccess
});
